export const hasDismissedOnboardingCookieName = 'hasDismissedOnboarding'
export const dataTipsDismissedCookieName = 'dataTipsDismissed'
export const devAuthToken = '_dev_auth_token'
export const genAiGettingStarted = 'genAiGettingStarted'
